module.exports = __webpack_public_path__ + "static/media/vandercook.be5841f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/vandercook.jpg
// module id = 88
// module chunks = 0